import { styled } from 'styled-components'

export const Container = styled.div``

export const Body = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
`

export const List = styled.div`
  width: 100%;
  /* border: 1px solid #645a5a; */
  /* border-radius: 10px; */
  padding-bottom: 5px;
  border: 1px solid var(--border-main, #ededed);

  /* border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px; */
`
export const LHead = styled.div`
  padding: 5px 8px 8px 8px;
  /* border-radius: 10px; */
  /* border-bottom-left-radius: 0px; */
  /* border-bottom-right-radius: 0px; */

  width: 100%;

  background-color: #f7f7f7;

  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const LBody = styled.div`
  padding: 0px 8px 8px 8px;
  width: 100%;
  /* height: 320px; */
  /* overflow-y: scroll; */

  > div {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-top: 1px solid var(--border-main, #ededed);
  }
`

export const HeadButton = styled.div`
  width: 250px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > div {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      font-weight: 700;
      color: #7f7f7f;
    }
    svg {
      fill: #7f7f7f;
    }
  }

  p {
    font-weight: 700;
  }
`
export const Header = styled.div<{bottom?: string}>`
  width: 100%;
  display: iniline-block;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-bottom: ${({ bottom }) => bottom || '10px'};

`
export const Header2 = styled.div<{bottom?: string}>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-bottom: ${({ bottom }) => bottom || '10px'};

`
export const SignalSet = styled.div`
  display: inline-block;
  position: relative;
  overflow-x: auto;
  width: calc(100% - 200px);
`

export const SignalSetElem = styled.p<{ selected: boolean }>`
  cursor: pointer;
  margin: 0;
  min-width: 110px;
  margin-right: 35px;
  color: ${({ selected }) => (selected ? '#000' : '#7f7f7f')};
  border-bottom: ${({ selected }) => (selected ? ' 2px solid #3BAAB0' : ' 2px solid white')};
  margin-bottom: 5px;
  font-weight: 700;
  padding: 7px 0px 0px 0px;
    align-items: center;
    display: inline-block;
  
`

export const AddSet = styled.div`
  display: flex;
  align-items: center;
  float: right;
  cursor: pointer;
  color: #7f7f7f;
  min-width: 130px;
  padding: 0px 0px 10px 0px;
  margin-top: 7px;
  

  p {
    margin: 0px;
  }
`

export const ShowMore = styled.div`
  width: 100%;
  height: 30px;
  border-top: 1px solid #e6e6e6;
  padding: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 0px;

  svg {
    margin-right: 10px;
    height: 15px;
    width: 20px;
  }
`

export const TextWithFile = styled.div`
  display: flex;
  align-items: center;
`

export const TableContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;

  table {
    border-collapse: collapse;

    thead {
      background-color: #f7f7f7;
      height: 30px;
      padding: 0px 5px;
      th {
        font-weight: 400;
        text-align: start;
      }
      tbody {
        padding: 0px 5px;
      }
    }
    width: 100%;
  }
`
